const CASHBACK_REGEX = /cash\s*-?\s*back/gi;

function sanitizeCashbackLabel(value) {
  if (typeof value !== "string") {
    return value;
  }

  return value
    .replace(/cr[e�]dito\s*\/\s*cash\s*-?\s*back/gi, "credito")
    .replace(CASHBACK_REGEX, "credito");
}

function replaceCashbackMentions(rootElement) {
  if (!rootElement || typeof NodeFilter === "undefined") {
    return;
  }

  const textWalker = document.createTreeWalker(rootElement, NodeFilter.SHOW_TEXT, null, false);
  const textNodes = [];

  while (textWalker.nextNode()) {
    textNodes.push(textWalker.currentNode);
  }

  textNodes.forEach((textNode) => {
    const parentTag = textNode.parentElement && textNode.parentElement.tagName;
    if (!parentTag || parentTag === "SCRIPT" || parentTag === "STYLE") {
      return;
    }

    const originalText = textNode.nodeValue;
    const sanitizedText = sanitizeCashbackLabel(originalText);
    if (originalText !== sanitizedText) {
      textNode.nodeValue = sanitizedText;
    }
  });

  const attrSelectors = ["[title]", "[aria-label]", "[placeholder]"];
  rootElement.querySelectorAll(attrSelectors.join(",")).forEach((element) => {
    ["title", "aria-label", "placeholder"].forEach((attrName) => {
      const attrValue = element.getAttribute(attrName);
      if (!attrValue) {
        return;
      }

      const sanitizedValue = sanitizeCashbackLabel(attrValue);
      if (sanitizedValue !== attrValue) {
        element.setAttribute(attrName, sanitizedValue);
      }
    });
  });
}

function getColumnChildren(rowElement) {
  return Array.from(rowElement.children).filter((child) => {
    return child.className && child.className.indexOf("col") >= 0;
  });
}

function getListButtonColumn(columns) {
  return columns.find((column) => {
    if (column.querySelector("#btlistar")) {
      return true;
    }

    const actionButton = column.querySelector("button, a");
    return actionButton && /listar/i.test((actionButton.textContent || "").trim());
  });
}

function getExistingMoreButtonColumn(columns) {
  return columns.find((column) => {
    return column.querySelector("#btmaisfiltros") || column.querySelector("[data-draco-more-filters='1']");
  });
}

function createMoreFiltersColumn() {
  const moreColumn = document.createElement("div");
  moreColumn.className = "col-6 col-sm-6 col-md-2 col-lg-2";
  moreColumn.setAttribute("data-draco-more-filters", "1");

  const button = document.createElement("button");
  button.type = "button";
  button.className = "btn btn-secondary btn-sm btn-block crud-more-filters-btn";
  button.setAttribute("data-draco-more-label", "Mais filtros");
  button.innerHTML = "<i class='fa fa-sliders'></i>";

  moreColumn.appendChild(button);
  return moreColumn;
}

function buildBaseCard(role, ownerKey) {
  const card = document.createElement("div");
  card.className = `card mb-3 ${role}`;
  card.setAttribute("data-draco-owner", ownerKey);

  const cardBody = document.createElement("div");
  cardBody.className = "card-body";
  card.appendChild(cardBody);

  return { card, cardBody };
}

function ensureOwnerKey(listCardElement) {
  if (!listCardElement.dataset.dracoOwner) {
    listCardElement.dataset.dracoOwner = `crud-${Date.now()}-${Math.floor(Math.random() * 100000)}`;
  }

  return listCardElement.dataset.dracoOwner;
}

function findByRole(ownerParentElement, ownerKey, roleClass) {
  return Array.from(ownerParentElement.children).find((child) => {
    return child.classList && child.classList.contains(roleClass) && child.getAttribute("data-draco-owner") === ownerKey;
  });
}

function ensureActionCard(listCardElement, ownerKey) {
  const ownerParent = listCardElement.parentElement;
  if (!ownerParent) {
    return null;
  }

  const cardFooter = listCardElement.querySelector(".card-footer");
  const originalNewButton = cardFooter
    ? Array.from(cardFooter.querySelectorAll("button, a")).find((element) => {
      return /novo|incluir|adicionar/i.test((element.textContent || "").trim());
    })
    : null;

  let actionCard = findByRole(ownerParent, ownerKey, "crud-action-card");

  if (!originalNewButton) {
    if (actionCard) {
      actionCard.remove();
    }
    return null;
  }

  if (!actionCard) {
    const built = buildBaseCard("crud-action-card", ownerKey);
    actionCard = built.card;
    ownerParent.insertBefore(actionCard, listCardElement);
  }

  const actionCardBody = actionCard.querySelector(".card-body");
  if (!actionCardBody) {
    return actionCard;
  }

  let topNewButton = actionCardBody.querySelector("[data-draco-top-new='1']");
  if (!topNewButton) {
    actionCardBody.innerHTML = "";
    topNewButton = document.createElement("button");
    topNewButton.setAttribute("data-draco-top-new", "1");
    actionCardBody.appendChild(topNewButton);
  }

  topNewButton.type = "button";
  topNewButton.className = `${originalNewButton.className || "btn btn-success"} crud-top-new-btn`;
  topNewButton.className = topNewButton.className.replace(/\s*btn-block\s*/g, " ").trim();
  topNewButton.innerHTML = originalNewButton.innerHTML;
  topNewButton.__dracoOriginalNewButton = originalNewButton;

  if (!topNewButton.__dracoClickHandler) {
    topNewButton.__dracoClickHandler = (event) => {
      event.preventDefault();
      if (topNewButton.__dracoOriginalNewButton) {
        topNewButton.__dracoOriginalNewButton.click();
      }
    };
    topNewButton.addEventListener("click", topNewButton.__dracoClickHandler);
  }
  const originalButtonColumn = originalNewButton.closest("[class*='col-']") || originalNewButton.parentElement;
  if (originalButtonColumn) {
    originalButtonColumn.classList.add("crud-original-new-hidden");
  }

  return actionCard;
}

function detectTableStartIndex(columns) {
  let tableIndex = columns.findIndex((column) => {
    return column.querySelector("table") ||
      column.querySelector(".table-responsive") ||
      column.querySelector(".vue-bootstrap4-table") ||
      column.querySelector("[class*='easy-data-table']");
  });

  if (tableIndex >= 0) {
    return tableIndex;
  }

  tableIndex = columns.findIndex((column) => {
    const styleValue = column.getAttribute("style") || "";
    return styleValue.indexOf("margin-top") >= 0;
  });

  return tableIndex;
}

function configureMoreFilters(filtersGrid, searchCardElement) {
  const columns = getColumnChildren(filtersGrid);
  const listButtonColumn = getListButtonColumn(columns);
  const existingMoreColumn = getExistingMoreButtonColumn(columns);

  if (existingMoreColumn) {
    const existingMoreButton = existingMoreColumn.querySelector("button, a");
    if (existingMoreButton) {
      existingMoreButton.classList.add("crud-more-filters-btn");
      existingMoreButton.setAttribute("data-draco-more-label", "Mais filtros");
      existingMoreButton.addEventListener("click", () => {
        const isCollapsed = searchCardElement.classList.toggle("crud-filters-collapsed");
        existingMoreButton.setAttribute("data-draco-more-label", isCollapsed ? "Mais filtros" : "Menos filtros");
      });
    }
    return;
  }

  const plainFilterColumns = columns.filter((column) => {
    return column !== listButtonColumn;
  });

  if (plainFilterColumns.length <= 4) {
    return;
  }

  plainFilterColumns.forEach((column, index) => {
    if (index >= 4) {
      column.classList.add("crud-filter-extra");
    }
  });

  searchCardElement.classList.add("crud-filters-collapsed");

  const generatedMoreColumn = createMoreFiltersColumn();
  if (listButtonColumn) {
    filtersGrid.insertBefore(generatedMoreColumn, listButtonColumn);
  } else {
    filtersGrid.appendChild(generatedMoreColumn);
  }

  const generatedMoreButton = generatedMoreColumn.querySelector("button");
  if (generatedMoreButton) {
    generatedMoreButton.addEventListener("click", () => {
      const isCollapsed = searchCardElement.classList.toggle("crud-filters-collapsed");
      generatedMoreButton.setAttribute("data-draco-more-label", isCollapsed ? "Mais filtros" : "Menos filtros");
    });
  }
}

function ensureSearchCard(listCardElement, ownerKey) {
  const ownerParent = listCardElement.parentElement;
  if (!ownerParent) {
    return null;
  }

  let searchCard = findByRole(ownerParent, ownerKey, "crud-search-card");
  if (!searchCard) {
    const built = buildBaseCard("crud-search-card", ownerKey);
    searchCard = built.card;

    const actionCard = findByRole(ownerParent, ownerKey, "crud-action-card");
    if (actionCard && actionCard.nextSibling) {
      ownerParent.insertBefore(searchCard, actionCard.nextSibling);
    } else {
      ownerParent.insertBefore(searchCard, listCardElement);
    }
  }

  if (searchCard.dataset.dracoFiltersReady === "1") {
    return searchCard;
  }

  const cardBody = listCardElement.querySelector(".card-body");
  if (!cardBody) {
    return searchCard;
  }

  const firstRow = cardBody.querySelector(".row");
  if (!firstRow) {
    return searchCard;
  }

  const allColumns = getColumnChildren(firstRow);
  if (allColumns.length < 4) {
    return searchCard;
  }

  const tableColumnIndex = detectTableStartIndex(allColumns);
  if (tableColumnIndex <= 0) {
    return searchCard;
  }

  const filterColumns = allColumns.slice(0, tableColumnIndex);
  if (filterColumns.length < 3) {
    return searchCard;
  }

  const searchCardBody = searchCard.querySelector(".card-body");
  if (!searchCardBody) {
    return searchCard;
  }

  const filtersGrid = document.createElement("div");
  filtersGrid.className = "row crud-filters-grid";

  filterColumns.forEach((column) => {
    filtersGrid.appendChild(column);
    column.classList.add("crud-filter-item");
  });

  searchCardBody.appendChild(filtersGrid);
  configureMoreFilters(filtersGrid, searchCard);
  searchCard.dataset.dracoFiltersReady = "1";

  return searchCard;
}

function normalizeLabel(value) {
  return (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function isLikelyTotalizer(label) {
  return /(total|vencid|a vencer|juros|multa|desconto|selecionad|soma|cancelad|aberto|faturad|custo|cashback|recebid|pago|entrad|saida|diferenc|parcela)/.test(label);
}

function findLabelIndex(labels, terms) {
  return labels.findIndex((label) => {
    return terms.some((term) => label.indexOf(term) >= 0);
  });
}

function resolvePrimaryIndexes(entries) {
  const labels = entries.map((entry) => normalizeLabel(entry.item.textContent));
  const preferredIndexes = [];

  const totalFaturadoIndex = findLabelIndex(labels, ["total faturado"]);
  const totalCustoIndex = findLabelIndex(labels, ["total custo"]);
  if (totalFaturadoIndex >= 0 && totalCustoIndex >= 0) {
    preferredIndexes.push(totalFaturadoIndex, totalCustoIndex);
  } else {
    const totalPagarIndex = findLabelIndex(labels, ["total geral a pagar", "total a pagar"]);
    const somaTitulosIndex = findLabelIndex(labels, ["soma dos titulos", "soma titulos", "soma rtitulo", "rtitulo"]);
    if (totalPagarIndex >= 0 && somaTitulosIndex >= 0) {
      preferredIndexes.push(totalPagarIndex, somaTitulosIndex);
    }
  }

  const uniquePreferred = [];
  preferredIndexes.forEach((index) => {
    if (index >= 0 && !uniquePreferred.includes(index)) {
      uniquePreferred.push(index);
    }
  });

  for (let index = 0; uniquePreferred.length < Math.min(entries.length, 2); index += 1) {
    if (!uniquePreferred.includes(index)) {
      uniquePreferred.push(index);
    }
  }

  return uniquePreferred;
}

function createMoreTotalizersControl(ownerElement) {
  const wrapper = document.createElement("div");
  wrapper.className = "crud-totalizers-toggle-wrap";
  wrapper.setAttribute("data-draco-more-totalizers", "1");

  const button = document.createElement("button");
  button.type = "button";
  button.className = "btn btn-link btn-sm crud-more-totalizers-btn";

  const syncLabel = () => {
    const isExpanded = ownerElement.classList.contains("crud-totalizers-expanded");
    button.innerHTML = isExpanded
      ? "<i class='fa fa-minus'></i> Menos"
      : "<i class='fa fa-plus'></i> Mais";
  };

  button.addEventListener("click", () => {
    ownerElement.classList.toggle("crud-totalizers-expanded");
    syncLabel();
  });

  syncLabel();
  wrapper.appendChild(button);
  return wrapper;
}

function applyTotalizerCollapse(ownerElement, entries, insertAfterElement) {
  if (!ownerElement || ownerElement.dataset.dracoTotalsReady === "1") {
    return;
  }

  if (!entries || entries.length <= 2) {
    return;
  }

  const labels = entries.map((entry) => normalizeLabel(entry.item.textContent));
  const likelyTotalizers = labels.filter((label) => isLikelyTotalizer(label));
  if (likelyTotalizers.length < 2) {
    return;
  }

  const primaryIndexes = resolvePrimaryIndexes(entries);
  const extraEntries = entries.filter((entry, index) => !primaryIndexes.includes(index));
  if (!extraEntries.length) {
    return;
  }

  extraEntries.forEach((entry) => {
    entry.host.classList.add("crud-totalizer-extra");
  });

  ownerElement.classList.add("crud-totalizers-collapsed");

  const control = createMoreTotalizersControl(ownerElement);
  if (insertAfterElement && insertAfterElement.parentElement) {
    insertAfterElement.parentElement.insertBefore(control, insertAfterElement.nextSibling);
  } else {
    ownerElement.appendChild(control);
  }

  ownerElement.dataset.dracoTotalsReady = "1";
}

function enhanceTotalizerGroups(listCardElement) {
  const listGroups = Array.from(listCardElement.querySelectorAll(".list-group")).filter((group) => {
    return group.closest("#pnlista") === listCardElement;
  });

  listGroups.forEach((group) => {
    const items = Array.from(group.children).filter((child) => {
      return child.classList && (child.classList.contains("lstdettot") || child.classList.contains("lstdetrec"));
    });

    if (items.length <= 2) {
      return;
    }

    const entries = items.map((item) => ({
      host: item,
      item
    }));

    applyTotalizerCollapse(group, entries, group);
  });
}

function enhanceTotalizerRows(listCardElement) {
  const rows = Array.from(listCardElement.querySelectorAll(".row")).filter((row) => {
    return row.closest("#pnlista") === listCardElement;
  });

  rows.forEach((row) => {
    if (row.querySelector("table, .vue-bootstrap4-table")) {
      return;
    }

    const columns = getColumnChildren(row);
    const totalizerColumns = columns.filter((column) => {
      return column.querySelector(".lstdettot, .lstdetrec");
    });

    if (totalizerColumns.length <= 2) {
      return;
    }

    const entries = totalizerColumns.map((column) => ({
      host: column,
      item: column.querySelector(".lstdettot, .lstdetrec")
    })).filter((entry) => entry.item);

    applyTotalizerCollapse(row, entries, row);
  });
}

function hideRegisterCountRow(listCardElement) {
  const badges = Array.from(listCardElement.querySelectorAll(".bdg-qtd-reg-info"));
  badges.forEach((badge) => {
    const rowItem = badge.closest("li, a");
    if (!rowItem || rowItem.dataset.dracoRegisterHidden === "1") {
      return;
    }

    const rowLabel = normalizeLabel(rowItem.textContent || "");
    if (rowLabel.indexOf("registros") !== 0) {
      return;
    }

    const parentColumn = rowItem.closest("[class*='col-']");
    if (parentColumn && parentColumn.closest("#pnlista") === listCardElement) {
      parentColumn.classList.add("crud-register-count-hidden");
    } else {
      rowItem.classList.add("crud-register-count-hidden");
    }

    rowItem.dataset.dracoRegisterHidden = "1";
  });
}

function enhanceTotalizers(listCardElement) {
  if (!listCardElement) {
    return;
  }

  hideRegisterCountRow(listCardElement);
  enhanceTotalizerRows(listCardElement);
  enhanceTotalizerGroups(listCardElement);
}

function enhanceBreadcrumb(crudContainerElement) {
  const breadcrumbNav = crudContainerElement.querySelector(".crud-breadcrumb-nav, nav[aria-label='breadcrumb']");
  if (breadcrumbNav) {
    breadcrumbNav.classList.add("crud-breadcrumb-nav");
  }

  const breadcrumb = crudContainerElement.querySelector(".breadcrumb");
  if (breadcrumb) {
    breadcrumb.classList.add("crud-breadcrumb");
  }
}

function syncAuxVisibility(listCardElement, actionCardElement, searchCardElement) {
  const isListVisible = window.getComputedStyle(listCardElement).display !== "none";

  if (actionCardElement) {
    actionCardElement.style.display = isListVisible ? "" : "none";
  }

  if (searchCardElement) {
    searchCardElement.style.display = isListVisible ? "" : "none";
  }
}

function resolveCrudContainerFromListCard(listCardElement) {
  if (!listCardElement) {
    return null;
  }

  return listCardElement.closest("#dvcrud") || listCardElement.closest(".container-fluid") || listCardElement.parentElement;
}

function enhanceCrudContainer(crudContainerElement, forcedListCardElement = null) {
  if (!crudContainerElement) {
    return;
  }

  crudContainerElement.classList.add("crud-layout-root");
  enhanceBreadcrumb(crudContainerElement);

  const listCard = forcedListCardElement || crudContainerElement.querySelector("#pnlista.card");
  if (!listCard) {
    return;
  }

  listCard.classList.add("crud-list-card");

  const ownerKey = ensureOwnerKey(listCard);
  const actionCard = ensureActionCard(listCard, ownerKey);
  const searchCard = ensureSearchCard(listCard, ownerKey);
  syncAuxVisibility(listCard, actionCard, searchCard);
  enhanceTotalizers(listCard);
  replaceCashbackMentions(crudContainerElement);
}

let enhanceTimer = null;
let observerInitialized = false;

function scheduleEnhancement() {
  if (enhanceTimer) {
    window.clearTimeout(enhanceTimer);
  }

  enhanceTimer = window.setTimeout(() => {
    enhanceTimer = null;

    const handledListCards = new Set();

    const crudContainers = document.querySelectorAll("#dvcrud");
    crudContainers.forEach((crudContainer) => {
      const listCard = crudContainer.querySelector("#pnlista.card");
      if (listCard) {
        handledListCards.add(listCard);
      }
      enhanceCrudContainer(crudContainer, listCard);
    });

    const orphanListCards = document.querySelectorAll("#pnlista.card");
    orphanListCards.forEach((listCard) => {
      if (handledListCards.has(listCard)) {
        return;
      }

      const fallbackContainer = resolveCrudContainerFromListCard(listCard);
      if (fallbackContainer) {
        enhanceCrudContainer(fallbackContainer, listCard);
      }
    });

    replaceCashbackMentions(document.body);
  }, 80);
}

function initMutationObserver() {
  if (observerInitialized || typeof MutationObserver === "undefined") {
    return;
  }

  observerInitialized = true;
  const observer = new MutationObserver(() => {
    scheduleEnhancement();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"]
  });
}

const CrudLayoutBridge = {
  install(Vue) {
    Vue.mixin({
      mounted() {
        scheduleEnhancement();
        initMutationObserver();
      },
      updated() {
        scheduleEnhancement();
      }
    });
  }
};

export default CrudLayoutBridge;





